<template>
    <div id="five" class="mb-5" ref="observerEle" >
        <div class="type-line">
            <h3 class="type-title">問題討論</h3>
            <span class="prompt-line">
                <div class="prompt-item discuss" v-if="authCheck" @click="formToggle">提出新問題</div>
                <a href="user/login" class="prompt-item-login" title="" v-else>請先登入會員</a>
            </span>
        </div>
        <form action="course/discuss" method="post">
            <div class="spinner-border text-primary" role="status" v-if="isLoading">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="discuss-form" v-show="formActive">
                <p>問題討論內容</p>
                <textarea name="discussContent"></textarea>
                <button class="discuss-btn" type="submit">送出問題</button>
            </div>
            <input type="hidden" name="pageSlug" :value="slug">
            <input type="hidden" name="courseId" :value="id">
        </form>

        <p class="discuss-empty" v-if="discusses.length == 0">目前還沒有任何討論</p>

        <discuss-component v-for="discuss in discusses" :key="discuss.id"
            :discuss="discuss"
            :discuss-created-at="formatDate(discuss.createdAt)"
            :discuss-comments="discuss.DiscussComments"
            :comment-count="discuss.discussCommentsCount"
            :auth-check="authCheck"
            :login-user-pic-url="userPicUrl"
            :login-user-email="userName"
            :page-slug="slug"
        ></discuss-component>
    </div>
</template>

<script>
import DiscussComponent from 'Vue/Web/Common/DiscussComponent.vue';

export default {
    name: 'SectionDiscussComponent',
    components: {
        DiscussComponent,
    },
    props: {
        id: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        authCheck: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false,
        },
        slug: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        userPicUrl: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
        userName: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
            discusses: [],
            url: '/api/courseDiscuss',
            formActive: false,
        };
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    methods: {
        formToggle() {
            this.formActive = !this.formActive;
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.id) {
                        this.getResult();
                        observer.unobserve(this.$refs.observerEle); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.observerEle) {
                observer.observe(this.$refs.observerEle);
            }
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.id}`);
                this.discusses = response?.data ?? [];
                this.isLoading = false;

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    // this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor : #72ca4a;
.spinner-border {
    margin: 50px 50%;
}
.prompt-line {
    color: #666;
    .prompt-item {
        color: $maincolor;
        line-height: 19px;
        display: inline-block;
        border-bottom: 1px solid $maincolor;
        cursor: pointer;
        font-size: 16px;
        &:hover {
            color: darken($maincolor, 10%);
            transition: 0.3s;
        }
    }
    .prompt-item-login {
        color: $maincolor;
        line-height: 19px;
        display: inline-block;
        border-bottom: 1px solid $maincolor;
        &:hover {
            color: darken($maincolor, 10%);
            transition: 0.3s;
        }
    }
}

.discuss-form {
    padding-bottom: 30px;
    transition-duration: 0.5s;
    textarea {
        width: 100%;
        height: 100px;
        margin-bottom: 10px;
    }
    .discuss-btn {
        display: block;
        width: 150px;
        height: 40px;
        color: white;
        background-color: $maincolor;
        border: none;
        border-radius: 3px;
        transition: 0.3s;
        &:hover {
            background: lighten($maincolor, 10%);
            transition: 0.3s;
        }
    }
}

.discuss-open {
    display: block;
    transition-duration: 0.5s;
}

.discuss-comment {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .message-user {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 1rem;
        @media (max-width: 549px) {
            flex-wrap: wrap;
        }
        .message-user-pic {
            flex: 0 0 40px;
            border-radius: 50%;
            overflow: hidden;
        }
        .message-user-info {
            flex: 1;
            padding-left: 1.5rem;
            .message-user-name {
                color: #333;
            }
        }
    }
    textarea {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }
    .discuss-comment-btn {
        display: block;
        width: 150px;
        height: 40px;
        color: white;
        background-color: $maincolor;
        border: none;
        border-radius: 3px;
        transition: 0.3s;
        &:hover {
            background: lighten($maincolor, 10%);
            transition: 0.3s;
        }
    }
}
</style>
